<div class="row tabla-seccion tabla-scroll mt-3 d-none d-xl-block">
    <div class="col-12">
        <div class="tabla card pb-3">
            <div class="p-3 pb-0">
                <h4 class="subtitulo-seccion pleca-izquierda" style="text-align: left;">
                    <strong>Detalle de votos por Casilla</strong>
                </h4>
                <div class="acta-digitalizada container-fluid">
                    <div class="row">
                        <div class="col-12 em12 pl-0">
                            <p class="font-medium text-left"> Imagen procedente de: </p>
                            <div class="container-fluid pl-0 my-2">
                                <div class="row">
                                    <div class="col-2 dis-flex ">
                                        <div class="grupo dis-flex cursor-hand" tooltip="Acta PREP digitalizada por medio de escáner." placement="top" max-width="500">
                                            <i class="far fa-file"></i>
                                            <i class="fas fa-print" aria-hidden="true"></i>
                                            <p> Escáner </p>
                                        </div>
                                    </div>
                                    <div class="col-1 dis-flex">
                                        <div class="grupo dis-flex cursor-hand" tooltip="Acta PREP digitalizada por medio de dispositivo móvil." placement="top" max-width="500">
                                            <i class="far fa-file"></i>
                                            <i class="fas fa-mobile-alt"></i>
                                            <p>Móvil {{showLabel ? "Casilla" : ''}}</p>
                                        </div>
                                    </div>
                                    <div class="col-2 dis-flex" *ngIf="!disableUrna">
                                        <div class="grupo dis-flex cursor-hand" tooltip="Acta PREP digitalizada por medio de urna electrónica." placement="top" max-width="500">
                                            <img *ngIf="!themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_urna.png'">
                                            <img *ngIf="themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_urna_rosa.png'">
                                            <p>Urna Electrónica</p>
                                            <div class="vline"></div>
                                        </div>
                                    </div>
                                    <div class="col-2 dis-flex" *ngIf="showCATD">
                                        <div class="grupo dis-flex cursor-hand" 
                                            tooltip="Acta PREP digitalizada por medio de dispositivo móvil."
                                            placement="top" max-width="500">
                                            <div class="grupo dis-flex">
                                                <div *ngIf="!themeService.isDarkTheme()" style="width: 33px;height: 20px;background-image: url('./assets/img/generales/logo_movil_catd.png');background-repeat: no-repeat;image-rendering: -webkit-optimize-contrast;background-size:contain;"></div>
                                                <div *ngIf="themeService.isDarkTheme()" style="width: 33px;height: 20px;background-image: url('./assets/img/generales/logo_movil_catd_rosa.png');background-repeat: no-repeat;image-rendering: -webkit-optimize-contrast;background-size:contain;"></div>
                                                <p class="leyenda">
                                                    Móvil CATD
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-2 dis-flex borde-izq">
                                        <div class="grupo gris dis-flex">
                                            <i class="far fa-file"></i>
                                            <i class="far fa-hourglass"></i>
                                            <p>Acta en proceso</p>
                                        </div>
                                    </div>
                                    <div class="col-3 dis-flex borde-izq">
                                        <div class="grupo dis-flex cursor-hand" 
                                            placement="top" >
                                            <div class="grupo dis-flex">
                                                <p class="leyenda" style="display: flex;">
                                                    <span class="dot-contabilizadas"></span>&nbsp;<strong class="label-contabilizada"> Contabilizada</strong>
                                                </p>
                                                <p class="leyenda" style="margin-left: 16px; display: flex;">
                                                    <span class="dot-no-contabilizadas"></span>&nbsp;<strong class="label-no-contabilizada">No Contabilizada</strong>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        <div class="contenido barraScrollH">
            <div class="container-fluid">
                <div class="table-responsive max-500">
                    <table class="table table-striped table-bordered header-scroll">
                        <thead>
                            <tr>
                                <th class="sticky-cell">
                                    <div class="dis-flex">
                                        <strong>Casilla</strong>
                                    </div>
                                </th>
                                <th class="sticky-cell">
                                    <div class="dis-flex">
                                        <ng-container>
                                            <strong>Acta digitalizada</strong>
                                        </ng-container>
                                    </div>
                                </th>
                                <th *ngFor="let itemHeader of this._obtenerDatosService?.desglose?.headers">
                                    <div class="dis-flex">
                                        <ng-container *ngIf="itemHeader?.text != ''">
                                            <strong>{{itemHeader?.text}}</strong>
                                        </ng-container>
                                        <ng-container *ngIf="itemHeader?.info && itemHeader?.info == '1'">
                                            &nbsp;
                                            <span class="tooltip-outer"
                                              tooltip="Se refiere a la suma total de votos que realiza el sistema informático con base en los datos que muestran en cada Acta; podrás consultar la cifra del total de votos mostrado en cada Acta en la base de datos del PREP (numeral 26, fr. XIV del Anexo 13 del Reglamento de Elecciones)."
                                              placement="top" show-delay="200">
                                              <i class="fas fa-info-circle" aria-hidden="true"></i>
                                            </span>
                                        </ng-container>
                                        <ng-container *ngFor="let img of itemHeader?.imgs">
                                            <img class="img-partido" src="{{_obtenerDatosService.pathPartidos}}{{img}}">
                                        </ng-container>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let itemBody of this._obtenerDatosService?.desglose?.rows">
                                <td class="sticky-cell"> 
                                    <!-- <p *ngIf="itemBody.status == 'proceso'"><b>{{itemBody?.casilla?.numero}} {{itemBody?.casilla?.text}}</b></p> -->
                                    <div style="display: flex;">
                                        <span class="dot-contabilizadas" *ngIf="itemBody?.casilla?.contabilizada && itemBody?.casilla?.contabilizada == 1"></span>
                                        <span class="dot-no-contabilizadas" *ngIf="itemBody?.casilla?.contabilizada && itemBody?.casilla?.contabilizada == 0"></span>
                                        &nbsp;&nbsp;
                                        <a [routerLink]="['/'+contiendaActual+'/'+param+'/secciones/'+itemBody?.casilla?.seccion+'/casilla/'+itemBody?.casilla?.param]"><b>{{itemBody?.casilla?.numero}} {{itemBody?.casilla?.text}}</b> </a>
                                    </div>
                                </td>
                                <td class="sticky-cell">
                                    <a target="_blank" [href]="actasRoot + (itemBody.status.catd ? itemBody.status.catd : (itemBody.status.movil? itemBody.status.movil : (itemBody.status.scanner ? itemBody.status.scanner : itemBody.status.urna) ))" *ngIf="(itemBody.status != 'proceso' || itemBody.status != 'sin_acta') && itemBody?.casilla?.param">
                                        <ng-container *ngIf="itemBody.status.movil">
                                            <i class="far fa-file" aria-hidden="true"></i>
                                            <i class="fas fas fa-mobile-alt" aria-hidden="true"></i>
                                        </ng-container>
                                        <ng-container *ngIf="itemBody.status.scanner">
                                            <i class="far fa-file" aria-hidden="true"></i>
                                            <i class="fas fa-print" aria-hidden="true"></i>
                                        </ng-container>
                                        <ng-container *ngIf="itemBody.status.catd">
                                            <img *ngIf="!themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_movil_catd.png'">
                                            <img *ngIf="themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_movil_catd_rosa.png'">
                                        </ng-container>
                                        <ng-container *ngIf="!disableUrna && itemBody.status.urna">
                                            <img *ngIf="!themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_urna.png'">
                                            <img *ngIf="themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_urna_rosa.png'">
                                        </ng-container>
                                        <ng-container *ngIf="itemBody.actaDigitalizada === '-'">
                                            <i class="far fa-file"></i>
                                            <i class="far fa-hourglass"></i>
                                        </ng-container>
                                    </a>
                                    <a target="_blank" *ngIf="(itemBody.status == 'proceso' || itemBody.status == 'sin_acta')  || !itemBody?.casilla?.param">
                                        <ng-container *ngIf="itemBody.status.movil">
                                            <i class="far fa-file" aria-hidden="true"></i>
                                            <i class="fas fas fa-mobile-alt" aria-hidden="true"></i>
                                        </ng-container>
                                        <ng-container *ngIf="itemBody.status.scanner">
                                            <i class="far fa-file" aria-hidden="true"></i>
                                            <i class="fas fa-print" aria-hidden="true"></i>
                                        </ng-container>
                                        <ng-container *ngIf="!disableUrna && itemBody.status.urna">
                                            <img *ngIf="!themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_urna.png'">
                                            <img *ngIf="themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_urna_rosa.png'">
                                        </ng-container>
                                        <ng-container *ngIf="itemBody.actaDigitalizada === '-'">
                                            <i class="far fa-file"></i>
                                            <i class="far fa-hourglass"></i>
                                        </ng-container>
                                        
                                        <div class="txGris" *ngIf="itemBody?.status == 'proceso' || itemBody?.status == 'sin_acta'">
                                            <i class="far fa-file txGris"></i>
                                            <i class="far fa-hourglass txGris"></i>
                                        </div>
                                    </a>
                                </td>
                                <td *ngFor="let itemVoto of itemBody.col;  let i=index;">
                                    <span *ngIf="i < itemBody.col.length-1; else observacion">{{itemVoto}}</span>
                                    <ng-template #observacion>
                                        <span class="{{ itemVoto == '-' ? '' : 'link-text'}}" (click)="scrollComponent('observaciones')">{{itemVoto}}</span>
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
            
    </div>
  </div>
</div>
